// extracted by mini-css-extract-plugin
module.exports = {"container":"SwitchScheduleItemType_container__21ySk","button":"SwitchScheduleItemType_button__3ICu0","buttonActive":"SwitchScheduleItemType_buttonActive__3gbKX"};